import BaseLayout from "./BaseLayout";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/admin") {
      navigate("/admin/all-referrals");
    }
  }, [location.pathname, navigate]);

  return <BaseLayout isAdmin={true} />;
};

export default AdminLayout;